import React, { createContext, useContext, useState, ReactNode } from "react";

interface HistoryPanelContextType {
    isHistoryPanelOpen: boolean;
    setIsHistoryPanelOpen: (isOpen: boolean) => void;
    toggleHistoryPanel: () => void;
    showChatHistoryBrowser: boolean;
    setShowChatHistoryBrowser: (show: boolean) => void;
    showChatHistoryCosmos: boolean;
    setShowChatHistoryCosmos: (show: boolean) => void;
}

const HistoryPanelContext = createContext<HistoryPanelContextType | undefined>(undefined);

export const HistoryPanelProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isHistoryPanelOpen, setIsHistoryPanelOpen] = useState(() => window.innerWidth > 768);
    const [showChatHistoryBrowser, setShowChatHistoryBrowser] = useState(false);
    const [showChatHistoryCosmos, setShowChatHistoryCosmos] = useState(false);

    const toggleHistoryPanel = () => {
        setIsHistoryPanelOpen(prev => !prev);
    };

    return (
        <HistoryPanelContext.Provider 
            value={{ 
                isHistoryPanelOpen, 
                setIsHistoryPanelOpen, 
                toggleHistoryPanel,
                showChatHistoryBrowser,
                setShowChatHistoryBrowser,
                showChatHistoryCosmos,
                setShowChatHistoryCosmos
            }}
        >
            {children}
        </HistoryPanelContext.Provider>
    );
};

export const useHistoryPanel = (): HistoryPanelContextType => {
    const context = useContext(HistoryPanelContext);
    if (!context) {
        throw new Error("useHistoryPanel must be used within a HistoryPanelProvider");
    }
    return context;
};
